import { Callout } from "@octopusdeploy/design-system-components";
import type { ProcessTemplateListSummaryResource } from "@octopusdeploy/octopus-server-client";
import * as React from "react";
import { ExpandableFormSection, Select, Summary } from "~/components/form/index";
import type { DropdownMenuOption } from "~/primitiveComponents/form/Select/DropDownMenu";
interface ProcessTemplateSelectorProps {
    selectedProcessTemplateSlug: string | undefined;
    setSelectedProcessTemplateSlug: (slug: string) => void;
    distinctTemplates: ProcessTemplateListSummaryResource[];
    isNew: boolean;
    isProcessTemplateUnavailable: boolean;
    onProcessTemplateChanged: (value: string | undefined) => void;
}
function mapProcessTemplatesToProcessTemplateOptions(processTemplates: ProcessTemplateListSummaryResource[]): DropdownMenuOption[] {
    return processTemplates.map((pt) => ({ value: pt.Slug, text: pt.Name }));
}
function ProcessTemplateNotFoundCallout() {
    return (<Callout type={"danger"} title={"This process template is no longer available."}>
            <div>Please select another template.</div>
        </Callout>);
}
export function ProcessTemplateSelector({ selectedProcessTemplateSlug, setSelectedProcessTemplateSlug, distinctTemplates, isNew, isProcessTemplateUnavailable, onProcessTemplateChanged }: ProcessTemplateSelectorProps) {
    const distinctProcessTemplateOptions = mapProcessTemplatesToProcessTemplateOptions(distinctTemplates);
    const selectedProcessTemplateName = distinctProcessTemplateOptions.find((option) => option.value === selectedProcessTemplateSlug)?.text;
    const summary = selectedProcessTemplateSlug
        ? Summary.summary(selectedProcessTemplateName ? <span>{selectedProcessTemplateName}</span> : <span>The selected process template is no longer available.</span>)
        : Summary.placeholder("Select a process template");
    const handleProcessTemplateChanged = (value: string | undefined) => {
        if (value) {
            setSelectedProcessTemplateSlug(value);
            onProcessTemplateChanged(value);
        }
    };
    return (<ExpandableFormSection isExpandedByDefault={isNew || isProcessTemplateUnavailable} errorKey="processTemplateSelection" title="Template" summary={summary} help={"Select the process template to run."}>
            <Select value={selectedProcessTemplateSlug} allowClear={false} onChange={handleProcessTemplateChanged} items={distinctProcessTemplateOptions} label="Select process template" placeholder={"Select process template"}/>
            {isProcessTemplateUnavailable && <ProcessTemplateNotFoundCallout />}
        </ExpandableFormSection>);
}
